export default __webpack_public_path__ + "static/media/insta04.af15c378.webp";